<template>
  <div class="job_center">
    <button
      class="uk-button uk-button-default uk-margin-small-right hamburger-button"
      type="button"
      uk-toggle="target: #offcanvas-usage"
      aria-label="漢堡"
    >
      <span><i class="fas fa-bars"></i></span>
    </button>
    <div id="offcanvas-usage" uk-offcanvas="overlay: false">
      <div class="uk-offcanvas-bar">
        <button
          class="uk-offcanvas-close"
          type="button"
          uk-close
          aria-label="關閉按鍵"
        ></button>
        <div class="uk-width-1-2@s uk-width-2-5@m">
          <ul
            class="uk-nav-default uk-nav-parent-icon"
            uk-nav="multiple: false"
          >
            <li>
              <router-link
                class="all_border"
                to="/About"
                @click="setSearchData('/About')"
              >
                <div>
                  <img src="../../img/nav1.svg" alt="" />
                </div>
                <div>
                  <p
                    class="sidebar_title"
                    :style="{ fontSize: fontSize.h4 + 'em' }"
                  >
                    中心簡介
                  </p>
                </div>
              </router-link>
            </li>
            <li>
              <router-link
                class="all_border"
                to="/news"
                @click="setSearchData('/news')"
                ><div>
                  <img src="../../img/nav2.svg" alt="" />
                </div>
                <div>
                  <p
                    class="sidebar_title"
                    :style="{ fontSize: fontSize.h4 + 'em' }"
                  >
                    最新消息
                  </p>
                </div></router-link
              >
            </li>

            <li class="uk-parent outsidenav uikOpen">
              <a href="" role="button">
                <div>
                  <img src="../../img/nav3.svg" alt="" />
                </div>
                <div>
                  <p
                    class="sidebar_title"
                    :style="{ fontSize: fontSize.h4 + 'em' }"
                  >
                    海外就業國家
                  </p>
                </div>
              </a>
              <ul class="uk-nav-sub">
                <li v-for="coun in countryList" :key="coun.nodeId" class="area">
                  <template
                    v-for="country in coun.countries"
                    :key="country.countryId"
                  >
                    <router-link
                      :to="`/${country.countryId}`"
                      title="國家代號"
                      @click="setSearchData(`/${country.countryId}`)"
                    >
                      <p
                        class="sidebar_inside"
                        :style="{ fontSize: fontSize.h4 + 'em' }"
                      >
                        {{ country.countryName }}
                      </p>
                    </router-link>
                  </template>
                </li>
              </ul>
            </li>

            <li
              class="uk-parent outsidenav uikOpen"
              v-for="(navMessage, index) in navbar"
              :key="index"
            >
              <a href="" role="button">
                <img :src="navMessage.navPic" :alt="navMessage.title" />
                <p
                  class="sidebar_title"
                  :style="{ fontSize: fontSize.h4 + 'em' }"
                >
                  {{ navMessage.title }}
                </p>
              </a>

              <ul class="uk-nav-sub">
                <li
                  v-for="(value, index) in navMessage.titleInside"
                  :key="index"
                >
                  <router-link
                    :to="`${value.link}`"
                    @click="setSearchData(`${value.link}`)"
                  >
                    <p
                      class="sidebar_inside"
                      :style="{ fontSize: fontSize.h4 + 'em' }"
                    >
                      {{ value.titleArea }}
                    </p>
                  </router-link>
                </li>
              </ul>
            </li>

            <li class="uk-parent outsidenav uikOpen">
              <a href="" role="button">
                <div>
                  <img src="../../img/nav5.svg" alt="" />
                </div>
                <div>
                  <p
                    class="sidebar_title"
                    :style="{ fontSize: fontSize.h4 + 'em' }"
                  >
                    海外就業指南
                  </p>
                </div>
              </a>
              <ul class="uk-nav-sub">
                <li
                  class="guide_group"
                  v-for="message in guides"
                  :key="message.pageId"
                >
                  <a
                    :href="message.pageContent"
                    :title="'[另開新視窗]' + message.nodeName"
                    target="_blank"
                  >
                    <p
                      class="sidebar_inside"
                      :style="{ fontSize: fontSize.h4 + 'em' }"
                    >
                      {{ message.pageTitle }}
                    </p>
                  </a>
                </li>
              </ul>
            </li>

            <li class="uk-parent outsidenav uikOpen">
              <a href="" role="button">
                <div>
                  <img src="../../img/nav6.svg" alt="" />
                </div>
                <div>
                  <p
                    class="sidebar_title"
                    :style="{ fontSize: fontSize.h4 + 'em' }"
                  >
                    海外返國專區
                  </p>
                </div>
              </a>
              <ul class="uk-nav-sub">
                <li class="guide_group">
                  <router-link
                    to="/Return_employment"
                    title="職場資訊"
                    @click="setSearchData('/Return_employment')"
                  >
                    <p
                      class="sidebar_inside"
                      :style="{ fontSize: fontSize.h4 + 'em' }"
                    >
                      職場資訊
                    </p>
                  </router-link>
                </li>
                <li
                  class="guide_group"
                  v-for="page in returnPageUrl"
                  :key="page.name"
                >
                  <a
                    :href="page.url"
                    :title="'[另開新視窗]' + page.title"
                    target="_blank"
                  >
                    <p
                      class="sidebar_inside"
                      :style="{ fontSize: fontSize.h4 + 'em' }"
                    >
                      {{ page.name }}
                    </p>
                  </a>
                </li>
              </ul>
            </li>
            <li>
              <router-link
                class="all_border"
                :to="{ name: 'download' }"
                title="下載專區"
              >
                <div>
                  <img src="../../img/nav7.svg" alt="下載專區圖片" />
                </div>
                <div>
                  <p
                    class="sidebar_inside"
                    :style="{ fontSize: fontSize.h4 + 'em' }"
                  >
                    下載專區
                  </p>
                </div>
              </router-link>
            </li>
            <li class="phoneDisplay">
              <router-link to="/w.map" class="inline_link"
                ><p :style="{ fontSize: fontSize.h4 + 'em' }" class="titleArea">
                  網站導覽
                </p></router-link
              >
              <router-link to="/faq" class="inline_link"
                ><p :style="{ fontSize: fontSize.h4 + 'em' }" class="titleArea">
                  常見問答
                </p></router-link
              >
              <router-link to="/ServiceEmail" class="inline_link"
                ><p :style="{ fontSize: fontSize.h4 + 'em' }" class="titleArea">
                  聯絡我們
                </p></router-link
              >
            </li>
            <li class="phoneDisplay">
              <div class="font_size">
                <a class="circle" @click="$emit('fontBig')" role="button">
                  <p :style="{ fontSize: fontSize.h5 + 'em' }" href="#">大</p>
                </a>
                <a class="circle" @click="$emit('fontMiddle')" role="button">
                  <p :style="{ fontSize: fontSize.h5 + 'em' }" href="#">中</p>
                </a>
                <a class="circle" @click="$emit('fontSmall')" role="button">
                  <p :style="{ fontSize: fontSize.h5 + 'em' }" href="#">小</p>
                </a>
              </div>
            </li>
          </ul>
        </div>
        <!-- 內容尾 -->
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, ref, inject } from "vue";
import { apiGuide, apiReturnWorkEachType, apiCountry } from "@/api/api.js";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
export default {
  name: "Hamburger",
  props: [],
  setup() {
    const store = useStore();
    const route = useRoute();
    let fontSize = inject("fontSize");
    const countryList = reactive([]);
    const guides = reactive([]);
    const navbar = ref([
      {
        title: "海外就業分享",
        navPic: require("../../img/nav4.svg"),
        titleInside: [
          {
            titleArea: "影音專區",
            link: "/video",
          },
          {
            titleArea: "專家建議",
            link: "/article",
          },
          {
            titleArea: "達人投稿",
            link: "/submit",
          },
        ],
      },
    ]);
    apiGuide()
      .then((res) => {
        res.data.forEach((i) => {
          guides.push(i);
        });
      })
      .catch((err) => {
        console.log(err);
      });

    apiCountry()
      .then((res) => {
        res.data.areas.forEach((area) => {
          countryList.push(area);
        });
      })
      .catch((err) => {
        console.log(err);
      });

    const returnPageUrl = reactive({
      returnEmployment: { url: "", name: "", title: "" },
      returnBusiness: { url: "", name: "", title: "" },
    });
    apiReturnWorkEachType().then(
      ({ data: { returnEmployment, returnBusiness } }) => {
        console.log(returnEmployment);
        console.log(returnBusiness);
        Object.assign(returnPageUrl.returnEmployment, {
          url: returnEmployment[0].pageContent,
          name: returnEmployment[0].nodeName,
          title: returnEmployment[0].pageTitle,
        });

        Object.assign(returnPageUrl.returnBusiness, {
          url: returnBusiness[0].pageContent,
          name: returnBusiness[0].nodeName,
          title: returnBusiness[0].pageTitle,
        });
      }
    );
    const setSearchData = (url) => {
      console.log(url);
      if (url != route.path) {
        store.dispatch("setSearchData", {
          keyword: "",
          page: 1,
        });
      }
    };

    return {
      navbar,
      countryList,
      guides,
      fontSize,
      returnPageUrl,
      setSearchData,
    };
  },
};
</script>

<style scoped lang="scss">
.sidebar_title {
  font-size: 1.375em;
}
.fa-bars {
  color: #fdcf17;
}
* {
  color: rgb(107, 107, 107);
}
.all_border {
  width: 100%;
}
span {
  font-size: 1.875em;
  color: $main_sec_color;
}
.uk-offcanvas-bar {
  top: 152px;
  width: 360;
  background: rgba(255, 255, 255, 0.9);
  color: #ffffff;
  @include md {
    top: 80px;
  }
  @include sm {
    top: 70px;
  }
}
.uk-offcanvas {
  position: absolute;
}
.uk-button-default {
  border: none;
}

.uk-button {
  padding: 0;
  margin-right: 15px;
}

.uk-nav > li {
  border-bottom: 1px solid $hr_gray;
  display: flex;

  a > img {
    // width: 17%;
    padding-right: 10px;
  }
}
.uikOpen {
  display: flex;
  flex-direction: column;
}

.uk-nav-sub,
.uk-nav > li > a {
  padding: 15px 30px;
}
.uk-nav-sub a {
  padding: 10px 0;
}

.hamburger-button:focus {
  outline: 2px dotted #000;
}

.font_size {
  @include flex_center();
  .circle {
    margin: 10px;
    @include flex_center();
    flex-direction: column;
    height: 40px;
    width: 40px;
    border: 1px solid #ccc;
    border-radius: 50%;
  }
  a {
    text-align: center;
    display: inline-block;
    padding: 0;
  }
}
.phoneDisplay {
  @include flex_center();
  .titleArea {
    padding: 0 10px;
    @include lg {
      font-size: $h5 !important;
    }
  }
  .inline_link {
    width: 30%;
    padding: 15px 0;
    h4 {
      @include lg {
        font-size: $h5 !important;
      }
    }
  }
}
.font_size {
  @include flex();
  transition: 0.3s ease-in-out;
  .circle {
    &:hover {
      background-color: $main_color;
    }
    &:hover p {
      color: #fff;
    }
    margin-left: 10px;
    @include flex_center();
    flex-direction: column;
    height: 40px;
    width: 40px;
    border: 1px solid #ccc;
    border-radius: 50%;
  }
  p {
    text-align: center;
    display: inline-block;
  }
}
.sidebar_inside {
  font-size: 1.375em;
}
</style>
